// Module
var code = "<li class=\"im-msg im-msg-tip\"> <div class=\"im-msg-time\"></div> <div class=\"im-msg-main\"> <div class=\"im-msg-tip-container\"> <span class=\"im-msg-tip-content\"></span> <span class=\"im-msg-redit-content\"></span> </div> </div> </li> ";
// Exports
module.exports = code;